import { PaxDto } from '@bandido/shared/dtos';

// TODO: esto viene así de hotelFareMetada.. habrá que tocarlo en algún momento. ¯\_(ツ)_/¯
export const calculateAdultsAndMinors = (occupancies: Record<string, any>[]) => {
  const today = new Date();
  const adultAge = 18;

  let adults = 0;
  let minors = 0;

  const servicePaxes = occupancies?.reduce((result:  PaxDto[], { paxes }) => [
    ...result,
    ...paxes
  ], [] as PaxDto[]) || [];

  servicePaxes.forEach(pax => {
    const birthDate = new Date(pax.dob);
    const age = today.getFullYear() - birthDate.getFullYear();
    const isBirthdayPassed =
      today.getMonth() > birthDate.getMonth() ||
      (today.getMonth() === birthDate.getMonth() && today.getDate() >= birthDate.getDate());

    const exactAge = isBirthdayPassed ? age : age - 1;

    if (exactAge >= adultAge) {
      adults++;
    } else {
      minors++;
    }
  });
  
  return { adults, minors };
};
